import { text, integer, index, uniqueIndex } from 'drizzle-orm/sqlite-core'
import { defineTable } from '@kubdee/sdk/schema'
import { connectorInstances } from './connectors-instances'

// ============================================================================
// connectors_webhook_events — Audit log + dedupe store for ingress webhooks
//
// Every webhook the router accepts gets one row. `(instance_id, event_id)` is
// unique so replays are dropped idempotently. `signature_valid` + payload_hash
// give us the forensic trail if a provider later disputes what was sent.
// ============================================================================
export const connectorWebhookEvents = defineTable(
  'connectors',
  'webhook_events',
  {
    id: text('id').primaryKey(),
    instanceId: text('instance_id')
      .notNull()
      .references(() => connectorInstances.id, { onDelete: 'cascade' }),
    eventId: text('event_id').notNull(),
    eventType: text('event_type'),
    signatureValid: integer('signature_valid').notNull().default(0),
    payloadHash: text('payload_hash').notNull(),
    payload: text('payload'),
    receivedAt: text('received_at').notNull(),
    processedAt: text('processed_at'),
    processingStatus: text('processing_status').notNull().default('pending'),
    error: text('error'),
    retryCount: integer('retry_count').notNull().default(0),
  },
  (table) => [
    uniqueIndex('connectors_webhook_events_instance_event_unique').on(
      table.instanceId,
      table.eventId,
    ),
    index('connectors_webhook_events_received_at_idx').on(table.receivedAt),
    index('connectors_webhook_events_status_received_idx').on(
      table.processingStatus,
      table.receivedAt,
    ),
  ],
)

export type ConnectorWebhookEvent = typeof connectorWebhookEvents.$inferSelect
export type NewConnectorWebhookEvent = typeof connectorWebhookEvents.$inferInsert
